module.exports = __webpack_public_path__ + "static/media/screencast-anfr-v7.0eda255.mp4";